import { render, staticRenderFns } from "./PrescriptionSale.vue?vue&type=template&id=e38b1ac6&scoped=true&"
import script from "./PrescriptionSale.vue?vue&type=script&lang=js&"
export * from "./PrescriptionSale.vue?vue&type=script&lang=js&"
import style0 from "./PrescriptionSale.vue?vue&type=style&index=0&id=e38b1ac6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e38b1ac6",
  null
  
)

export default component.exports